/* Holographic shimmer clock — drives ONE shared --holo-shine value (a sweeping
   0%→100% background-position) onto every shimmering element so they all glint at
   the exact same time and in the same direction: the header logo, the footer
   brand logo, and the homepage category headings. A single requestAnimationFrame
   loop, phase-locked to performance.now(), so any element that pauses and is
   re-revealed rejoins the sweep in phase. The loop pauses when the tab is hidden,
   a modal holds body.overflow-hidden, or no shimmer target is on screen. Respects
   prefers-reduced-motion (parks the glint mid-sweep). No dependencies, no globals. */
(function () {
  var DURATION = 3200; /* ms per sweep — matches the logo + the 3.2s brand cadence */
  var targets = [];
  var visible = [];
  var running = false;

  function anyVisible() {
    for (var i = 0; i < visible.length; i++) {
      if (visible[i]) return true;
    }
    return false;
  }

  function frame(now) {
    if (document.hidden || !anyVisible()) {
      running = false;
      return;
    }
    // While the cart drawer (or any overflow-hidden modal) is open, skip the
    // shine writes — repainting masked/clipped shimmers competes with the slide.
    // The loop stays alive and resumes the instant it closes.
    if (!document.body.classList.contains('overflow-hidden')) {
      var shine = ((now % DURATION) / DURATION * 100).toFixed(2) + '%';
      for (var i = 0; i < targets.length; i++) {
        targets[i].style.setProperty('--holo-shine', shine);
      }
    }
    window.requestAnimationFrame(frame);
  }

  function start() {
    if (!running && !document.hidden && anyVisible()) {
      running = true;
      window.requestAnimationFrame(frame);
    }
  }

  function collect() {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll('.collection__title h2.title')
    );
    // Header logo — its ::after foil overlay reads --holo-shine.
    var headerLogo = document.querySelector('.header__heading-logo-wrapper');
    if (headerLogo) nodes.push(headerLogo);
    // Footer brand logo — set the var on its media box; the ::after inherits it.
    var brandImg = document.querySelector(
      '.image-with-text__media img[src*="LA_sports_Logo"], .image-with-text__media img[src*="Logo-Photoroom"]'
    );
    if (brandImg && brandImg.closest) {
      var box = brandImg.closest('.image-with-text__media');
      if (box) nodes.push(box);
    }
    return nodes;
  }

  function init() {
    targets = collect();
    if (!targets.length) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (var i = 0; i < targets.length; i++) {
        targets[i].style.setProperty('--holo-shine', '50%');
      }
      return;
    }

    if ('IntersectionObserver' in window) {
      visible = targets.map(function () { return false; });
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var idx = targets.indexOf(entries[i].target);
          if (idx !== -1) visible[idx] = entries[i].isIntersecting;
        }
        start();
      });
      for (var j = 0; j < targets.length; j++) io.observe(targets[j]);
    } else {
      visible = targets.map(function () { return true; });
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) start();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
